import { createFileRoute } from '@tanstack/react-router'
import {UserProfile} from "@descope/react-sdk";
import { SettingsIcon } from 'lucide-react'
import { PageWrapper } from '@nxt-shared/ui/components/PageWrapper'
import { PageHeader } from '@nxt-shared/ui/components/PageHeader'
import { PageContent } from '@nxt-shared/ui/components/PageContent'
import { baseLanguage, useLanguage } from '@nxt-shared/i18n'
import { usePageTitle } from '../../../features/page-title/pageTitle'
import { me } from '../../../i18n.ts'

export const Route = createFileRoute('/me/_settings/account')({
  component: RouteComponent,
})

function RouteComponent() {
  const t = me.useT()
  const language = useLanguage()
  usePageTitle(t('pageTitle.account'))
  return (
    <PageWrapper>
      <PageHeader
        title={t('account.title')}
        icon={SettingsIcon}
        description={t('account.description')}
        transparent
      />
      <PageContent belowTransparentHeader className="pb-8 xl:pb-12">
        <UserProfile widgetId="user-authentication-widget" locale={baseLanguage(language)} />
      </PageContent>
    </PageWrapper>
  )
}
